/*
 * @Author: Chao Yang
 * @Date: 2019-12-17 02:08:37
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-07-28 02:16:38
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Document from 'src/app/domain/model/document';
import { BaseProxy } from '../base.proxy';
import { format } from 'date-fns';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class DocumentProxy extends BaseProxy {

  hasPassword(documentId: number) {
    return this._http.get<boolean>(`/ip/api/document/${documentId}/password`)
  }

  download(documentId: number): void {
    location.href = this.link(documentId, false);
  }

  downloadPackage(resourceId: string): void {
    location.href = '/ip/api/document?resourceId=' + resourceId;
  }

  flowPaper(id: number): Observable<any> {
    return this._http.post<any>(
      '/UserDocumentResponse/UserDocumentResponse.aspx/GenerateUserDocumentFile',
      { mcpDocumentID: id }
    );
  }

  getDocumentsWithEffectiveDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    effectiveDateFrom: Date,
    effectiveDateTo: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IDocument[]> {
    return this._http.post<Document.IDocument[]>(
      '/ip/api/document/folder/' +
      folderId +
      '?effectiveDateFrom=' +
      this.getDateStr(effectiveDateFrom) +
      '&effectiveDateTo=' +
      this.getDateStr(effectiveDateTo),
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }

  getDocumentsWithPostedDate(
    fundIds: number[],
    accountIds: number[],
    folderId: number,
    postedDateFrom: Date,
    postedDateTo: Date,
    clientTimeOffset: number,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IDocument[]> {
    return this._http.post<Document.IDocument[]>(
      '/ip/api/document/folder/' +
      folderId +
      '?postDateFrom=' +
      this.getDateStr(postedDateFrom) +
      '&postDateTo=' +
      this.getDateStr(postedDateTo) +
      '&clientTimeOffset=' +
      clientTimeOffset,
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }

  getTaxDocuments(
    fundIds: number[],
    accountIds: number[],
    from: Date,
    to: Date,
    accounts: IDtoAccountGroup.IAccountItem[]
  ): Observable<Document.IDocument[]> {
    return this._http.post<Document.IDocument[]>(
      '/ip/api/document/tax' +
      '?effectiveDateFrom=' +
      this.getDateStr(from) +
      '&effectiveDateTo=' +
      this.getDateStr(to),
      {
        accountIds,
        fundIds,
        accounts,
      }
    );
  }

  invalid(documentIds: number[]): Observable<number[]> {
    return this._http.post<number[]>('/ip/api/document/invalid', documentIds);
  }

  link(documentId: number, isView: boolean): string {
    return (
      '/ip/api/document/' +
      documentId +
      '/?clientTimeOffset=' +
      new Date().getTimezoneOffset() +
      '&isView=' +
      isView
    );
  }

  markRead(documentIds: number[]): Observable<void> {
    return this._http.post<void>('/ip/api/document/read', documentIds);
  }

  markUnread(documentIds: number[]): Observable<void> {
    return this._http.request<void>('delete', '/ip/api/document/unread', {
      body: documentIds,
    });
  }

  package(documentIds: number[]): Observable<string> {
    return this._http.post<string>(
      '/ip/api/document/?clientTimeOffset=' + new Date().getTimezoneOffset() + '&isView=false',
      documentIds
    );
  }

  valid(documentId: number): Observable<boolean> {
    return this._http.get<boolean>('/ip/api/document/' + documentId + '/valid');
  }

  getDocument(documentId: number) {
    return this._http.get(
      '/ip/api/document/' +
      documentId +
      '?clientTimeOffset=' +
      new Date().getTimezoneOffset(),
      {
        responseType: 'text',
      }
    );
  }
  
  createVideoAudit(documentId: number, isView: boolean) {
    return this._http.get(
      '/ip/api/document/' +
      documentId +
      '/?clientTimeOffset=' +
      new Date().getTimezoneOffset() +
      '&isView=' +
      isView,
      {
        responseType: 'text',
      }
    );
  }

  newGetDocuments(
    dealrelationshipId: number,
    start: Date,
    end: Date,
    byEffectiveDate: boolean
  ) {
    return this._http.get<any>(
      `ip/api/document/new/documents?dealrelationshipId=${dealrelationshipId}&start=${format(
        start,
        'yyyy-MM-dd'
      )}&end=${format(end, 'yyyy-MM-dd')}&byEffectiveDate=${byEffectiveDate}`
    );
  }

  newGetAllDocuments(
    fundIds: number[],
    companyIds: number[],
    start: Date,
    end: Date,
    byEffectiveDate: boolean
  ) {
    return this._http.post<any>(
      `ip/api/document/new/documents/all?start=${format(
        start,
        'yyyy-MM-dd'
      )}&end=${format(end, 'yyyy-MM-dd')}&byEffectiveDate=${byEffectiveDate}`,
      {
        fundIds: fundIds,
        companyIds: companyIds,
        dealRelationshipId: null,
      }
    );
  }

  newGetTaxocuments(fundIds: number[], companyIds: number[]) {
    return this._http.post<any>(`ip/api/document/new/documents/tax`, {
      fundIds: fundIds,
      companyIds: companyIds,
      dealRelationshipId: null,
    });
  }
}
